export enum SelectedLevel {
  ProductionOrder = 'ProductionOrder',
  Recipe = 'Recipe',
  Part = 'Part',
}
